module.exports = __webpack_public_path__ + "static/handshake-23fe1050ebb077984e025b1dfed17c9e.jpeg";